module.exports = __webpack_public_path__ + "img/wallet.a0c24efb.svg";